import React from "react";
import { Button, ButtonProps, useTheme } from "@mui/material";

const ResponsiveButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
	function ResponsiveButton(props, ref) {
		const theme = useTheme();
		const { sx, ...rest } = props;

		return (
			<Button
				ref={ref}
				sx={{
					textTransform: "none",
					width: { xs: "100%", sm: "auto" },
					typography: "text16Bold",
					borderRadius: 1,
					...sx
				}}
				disableElevation
				{...rest}
			/>
		);
	}
);

export default ResponsiveButton;
